import { get } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme, { color = 'primary' }) => ({
  root: {
    borderBottom: `1px solid ${get(theme, 'palette.bg.main')}`,
    display: 'flex',
    flexDirection: 'column',
    margin: '5px',
  },
  label: {
    color: get(theme, `palette.${color}.main`),
    fontSize: '12px',
    fontWeight: 'bold',
    height: '22px',
    lineHeight: '1.57',
    letterSpacing: '1px',
    textTransform: 'uppercase',
  },
  children: {
    color: `rgba(0, 0, 0, 0.38)`,
    fontSize: '14px',
    minHeight: '22px',
    lineHeight: '1.57',
    letterSpacing: 'normal',
    margin: `1px solid ${get(theme, `palette.${color}.main`)}`,
  },
}));

export default function DetailField(props) {
  const { children, label } = props;
  const { classes } = useStyles(props);

  return (
    <div className={classes.root}>
      <div className={classes.label}>{label}</div>
      <div className={classes.children}>{children}</div>
    </div>
  );
}

DetailField.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  color: PropTypes.string,
  children: PropTypes.shape({}).isRequired,
  label: PropTypes.string.isRequired,
};
